module.exports = __webpack_public_path__ + "static/media/suggested_credit.f791232b.svg";